import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";
import { AuthResetPassword } from "../../API/login";
import { showLoding } from "../../utils/tool";
import { message } from "antd";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see1, setSee1] = React.useState(false)
  const [see2, setSee2] = React.useState(false)
  const [see3, setSee3] = React.useState(false) 
  const navigate = useNavigate()
  const [identifier, setIdentifier] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [confirmPassword, setConfirmPassword] = React.useState("")
  const [confirmPassword2, setConfirmPassword2] = React.useState("")
  const handleAuthResetPassword = () => {
    if (!identifier) { message.error('請輸入手機號碼'); return }
    if (!password) { message.error('請輸入新密碼'); return }
    if (!confirmPassword) {
      return message.error('請輸入確認密碼')
    }
    if (confirmPassword !== confirmPassword2) {
      message.error('兩次密碼輸入不一致')
      return
    }
    showLoding(true);
    AuthResetPassword({
      identifier: (identifier || '').trim(),
      oldPassword: btoa((password || '').trim()),
      newPassword: btoa((confirmPassword || '').trim())
    }).then((res: any) => {
      message.success('修改成功')
      navigate('/login')
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false);
    })
  }

  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">忘記密碼</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">會員中心</div>

        <div className="h5:px-16">
          <div className="text-[#595959] text-[16px] my-[30px] text-center">如果您忘記目前的密碼，請點擊右下角聯繫客服找回。然後輸入表單修改您的新密碼！</div>
        </div>

        <div className="flex py-[75px] w-[543px] mx-auto h5:w-full">
          <div className="flex-1 px-[16px]">
            <div className="p-[20px] rounded-md"
            >
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  使用者手機號
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex pb-[36px]">
                  <input type="text"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                    style={{
                      border: "1px solid #cfc8d8",
                    }} />
                </div>
              </div>

              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  目前的密碼
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} >
                  <input type={`${see1 ? "password" : "text"}`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                  <img src={
                    see1 ? require("../../assets/image/login/eye-close.png") :
                      require("../../assets/image/login/eye-see.png")}
                    className="w-[22px] h-[22px] cursor-pointer ml-4"
                    onClick={() => setSee1(!see1)}
                    alt="" />
                </div>
              </div>
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  新密碼
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} >
                  <input type={`${see2 ? "password" : "text"}`}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                  <img src={
                    see2 ? require("../../assets/image/login/eye-close.png") :
                      require("../../assets/image/login/eye-see.png")}
                    className="w-[22px] h-[22px] cursor-pointer ml-4"
                    onClick={() => setSee2(!see2)}
                    alt="" />
                </div>
              </div>
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  確認新密碼
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} >
                  <input type={`${see3 ? "password" : "text"}`}
                    value={confirmPassword2}
                    onChange={(e) => setConfirmPassword2(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                  <img src={
                    see3 ? require("../../assets/image/login/eye-close.png") :
                      require("../../assets/image/login/eye-see.png")}
                    className="w-[22px] h-[22px] cursor-pointer ml-4"
                    onClick={() => setSee3(!see3)}
                    alt="" />
                </div>
              </div>
              <div>
                <div
                  onClick={() => handleAuthResetPassword()}
                  className="bg-[#6d6e71] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]">
                  重設密碼
                </div>
              </div>
            </div>
          </div>
        </div>


        <br /><br />
        <br /><br />
      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
